import Card from '../card';

/**
 * The AboutDataUsage component is used on the About page to display information concerning
 * external data usage of the weather data.
 *
 * props: none
 */

const AboutDataUsage = () => (
	<Card cardTitle="Data usage">
		<p>You may use the data on this website for projects, research, etc. but please do acknowledge the source.
			If you are unable to find the data you need in an easy-to-download format, please contact me.
			I will be happy to help.
		</p>
	</Card>
);

export default AboutDataUsage;



// WEBPACK FOOTER //
// ./components/about/about-data-usage.js